<script>
    import {Bar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Bar,
        mounted() {
            this.renderChart(
                {
                    labels: ['2017', '2018'],
                    datasets: [
                        {
                            label: 'ALCANCE 1',
                            backgroundColor: hexToRgba('#ff00a4', 70),
                            fill: true,
                            data: [59697, 67062]
                        },
                        {
                            label: 'ALCANCE 2',
                            backgroundColor: hexToRgba('#ff003f', 70),
                            fill: true,
                            data: [5706, 4845]
                        },
                        {
                            label: 'ALCANCE 3',
                            backgroundColor: hexToRgba('#ff6c00', 70),
                            fill: true,
                            data: [981, 775]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
